<template>
  <div class="LKMunMehHostViewForm">
    <div class="LKMunMehHostViewForm__content">
      <router-link class="LKMunMehHostViewForm__content__link" :to="getListLink()">
        <v-row>
          <v-col cols="8">
            <h3
              class="LKMunMehHostViewForm__title"
              v-text="munMeh.name"
            />
          </v-col>
          <template v-if="!isMarksHidden">
            <v-col cols="4">
              <v-row>
                <v-col :cols="3" />

                <v-col cols="3" class="text-right">
                  <div
                    class="LKMunMehHostViewForm__title bold"
                    style="display: inline-block;"
                    v-text="getSumForExpertOne"
                  />
                </v-col>
                <v-col cols="3" class="text-right">
                  <div
                    class="LKMunMehHostViewForm__title bold"
                    style="display: inline-block;"
                    v-text="getSumForExpertTwo"
                  />
                </v-col>
                <v-col cols="3" class="text-right">
                  <div
                    class="LKMunMehHostViewForm__title bold"
                    v-text="getSumForExpertThree"
                  />
                </v-col>
              </v-row>
            </v-col>
          </template>
        </v-row>
      </router-link>

      <hr class="LKMunMehHostViewForm__line">

      <template v-if="!activeForm">
        <p>Форма не загружена. Возможно такой формы не существует.</p>
      </template>
      <template v-else>
        <v-row>
          <v-col :cols="6">
            <h4
              class="LKMunMehHostViewForm__content__title__header mx-0"
              v-text="'Позиция оценивания'"
            />
          </v-col>
          <v-col :cols="6">
            <v-layout row align-center justify-end>
              <v-spacer />
              <h4
                class="LKMunMehHostViewForm__content__title__header"
                v-text="'Макс. балл'"
              />

              <template v-if="!isMarksHidden">
                <h4
                  class="LKMunMehHostViewForm__content__title__header"
                  v-text="'Эксперт 1'"
                />
                <h4
                  class="LKMunMehHostViewForm__content__title__header"
                  v-text="'Эксперт 2'"
                />
                <h4
                  class="LKMunMehHostViewForm__content__title__header"
                  v-text="'Эксперт 3'"
                />
              </template>
            </v-layout>
          </v-col>
        </v-row>

        <template v-if="isGeneral">
          <FormLink
            v-for="(item, idx) in activeForm.data"
            :key="item.id"
            :get-link-builder="getLevelLinkBuilder"
            :idx="idx"
            :item="item"
            bold
            :marks-hidden="isMarksHidden"
            class="LKMunMehHostViewForm__content__link"
          />
        </template>
        <template v-else>
          <FormLink
            v-for="(link, index) in openedLinks"
            :key="`Opened.${link.index}`"
            :get-link-builder="getLevelLinkBuilder"
            :idx="link.index"
            :item="link.level"
            :bold="index === 0"
            :marks-hidden="isMarksHidden"
            class="LKMunMehHostViewForm__content__link"
          />

          <template v-if="levelDescription">
            <hr class="LKMunMehHostViewForm__line">

            <div class="LKMunMehHostViewForm__content__level-description" v-text="levelDescription" />
          </template>

          <template v-if="hasParameters">
            <hr class="LKMunMehHostViewForm__line">

            <FormLowLevels
              ref="FourLevels"
              :mun-meh-id="munMeh.id"
              :parent="currentLevel"
              :disabled="isLoadingAsyncData"
              :parent-idx="latestIndex"
              :marks-hidden="isMarksHidden"
            />
          </template>
        </template>
      </template>
    </div>

    <template v-if="activeForm">
      <template v-if="!isGeneral && !hasParameters">
        <div class="LKMunMehHostViewForm__content">
          <FormLink
            v-for="(item, idx) in currentLevel.items"
            :key="item.id"
            :get-link-builder="getLevelLinkBuilder"
            :idx="idx"
            :item="item"
            class="LKMunMehHostViewForm__content__link"
            :marks-hidden="isMarksHidden"
          />
        </div>
      </template>
    </template>

    <Footer
      v-if="hasParameters"
      :loading="isLoadingAsyncData"
      @next="goToNext"
      @main="onGoToForm"
      @prev="goToPrev"
    />
  </div>
</template>

<script>
import MunMehLevelMixin from '@/views/LKMunMeh/mixins/MunMehLevelMixin'

import { LK_MUN_MEH_FORM_HOST_VIEW_ROUTES as ROUTES } from '../utils'
import { LKMunMehHostViewMapper as StoreMapper } from '../store'

import { lkMapper } from '@/store/modules/lk'

const Footer = () => import(
  /* webpackChunkName: "LKMunMehHostViewLink" */
  '@/views/LKMunMeh/HostView/components/LKMunMehHostViewFooter.vue'
)

const FormLink = () => import(
  /* webpackChunkName: "LKMunMehHostViewLink" */
  '@/views/LKMunMeh/HostView/components/LKMunMehHostViewLink.vue'
)

const FormLowLevels = () => import(
  /* webpackChunkName: "LKMunMehHostViewFourLevels" */
  '@/views/LKMunMeh/HostView/components/LKMunMehHostViewFourLevels.vue'
)

export const getKey = (munMehId, formId) => {
  const storeKeys = {
    munMehId,
    formId,
  }

  const id = Object.keys(storeKeys).reduce((acc, key) => {
    if (storeKeys[key]) acc.push(`${key}/${storeKeys[key]}`)
    return acc
  }, []).join('/')

  return id
}

export default {
  name: 'LKMunMehHostViewForm',
  formRoute: ROUTES.FORM,
  anyLevelRoute: ROUTES.ANY_LEVEL,
  components: {
    Footer,
    FormLink,
    FormLowLevels,
  },
  mixins: [MunMehLevelMixin],
  props: {
    formId: Number,
    form: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    isMarksHidden: false,
  }),
  computed: {
    ...StoreMapper.mapState(['values']),
    ...StoreMapper.mapGetters(['getMarkForExpertThreeLevel', 'getMarkForExpertOneLevel', 'getMarkForExpertTwoLevel']),
    ...lkMapper.mapGetters(['profile']),
    activeForm() {
      return this.form
    },
    getSumForExpertOne() {
      if (!this.activeForm || !this.activeForm.data) {
        return 0
      }

      return this.activeForm.data.reduce((acc, cur) => acc + this.getMarkForExpertOneLevel(cur.id), 0)
    },
    getSumForExpertTwo() {
      if (!this.activeForm || !this.activeForm.data) {
        return 0
      }

      return this.activeForm.data.reduce((acc, cur) => acc + this.getMarkForExpertTwoLevel(cur.id), 0)
    },
    getSumForExpertThree() {
      if (!this.activeForm || !this.activeForm.data) {
        return 0
      }

      return this.activeForm.data.reduce((acc, cur) => acc + this.getMarkForExpertThreeLevel(cur.id), 0)
    },
  },
  watch: {
    hasParameters: {
      async handler(v) {
        if (!v) return
        await this.onGetLevelData()
      },
      immediate: true,
    },
    levels: {
      async handler(v) {
        if (!v) return
        await this.onGetLevelData()
      },
      immediate: true,
    },
    form: {
      handler(v) {
        if (!v) return
        this.isMarksHidden = v.user_id === this.profile.id
      },
      immediate: true,
    },
  },
  methods: {
    ...StoreMapper.mapActions(['getLevelData', 'getForm', 'getFormMarks', 'getFormLoggedIndicators']),
    onSaveThirdLevelDocuments() {
      // Need to be overridden.
      return true
    },
    async onGetLevelData() {
      if (!this.hasParameters) {
        return
      }
      const { params } = this.$route
      const { munMehId, formId } = params
      const { currentLevel } = this
      await this.getLevelData({ munMehId, formId, parentLevel: currentLevel })
    },

  },
}
</script>

<style lang="scss">
.LKMunMehHostViewForm {
  @import "~@/views/LKMunMeh/styles/_MunMehFormStylesheet.scss";
}
</style>
